import React, { useEffect, useState, useTransition } from "react";
import "./projectminers.scss";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Modal, ProgressBar } from "react-bootstrap";
import MineProjectSlide from "./MineProjectSlide";
import Web3 from "web3";
import { nodeMinerContract } from "../../../utils/contractHelpers";
import Environment from "../../../utils/Environment";
import { useTranslation } from "react-i18next";

function SampleNextArrow(props) {
  const { className, onClick, hideArrow } = props;
  return !hideArrow ? (
    <div className={className} onClick={onClick}>
      <img
        src="\next-arrow.svg"
        alt="Next"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\next-arrow-dark.svg"
        alt="Next"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  ) : (
    <div
      className={className}
      onClick={onClick}
      style={{ pointerEvents: "none", opacity: "0.5" }}
    >
      <img
        src="\next-arrow.svg"
        alt="Next"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\next-arrow-dark.svg"
        alt="Next"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick, hideArrow } = props;
  return !hideArrow ? (
    <div className={className} onClick={onClick}>
      <img
        src="\prev-icon.svg"
        alt="Prev"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\prev-icon-dark.svg"
        alt="Prev"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  ) : (
    <div
      className={className}
      onClick={onClick}
      style={{ pointerEvents: "none", opacity: "0.5" }}
    >
      <img
        src="\prev-icon.svg"
        alt="Prev"
        className="img-fluid d-none show-in-light-theme"
      />
      <img
        src="\prev-icon-dark.svg"
        alt="Prev"
        className="img-fluid hide-in-light-theme"
      />
    </div>
  );
}

const ProjectMiners = () => {
  var languageselected = localStorage.getItem("codelanguage");
  const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
  const { t } = useTranslation();
  const [firtMillon, setFirtMillon] = useState(null);
  const web3 = new Web3(
    "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/"
  );
  const getValue = async () => {
    let contract = nodeMinerContract(Environment.nodeMinerSale, web3);
    let buy = await contract?.methods?.accretionThreshold().call();
    buy = buy / 10 ** 6;
    setFirtMillon(buy);
    console.log(buy, "buy");
  };
  useEffect(() => {
    if (web3) {
      getValue();
    }
  }, [web3]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    nextArrow: <SampleNextArrow hideArrow={currentSlide >= totalSlides - 1} />,
    prevArrow: <SamplePrevArrow hideArrow={currentSlide === 0} />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          swipe: true,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          swipe: true,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          swipe: true,
        },
      },
    ],
  };

  const targetTime = 1738659600000;
  const [timeLeft, setTimeLeft] = useState(targetTime - Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining = targetTime - Date.now();
      setTimeLeft(remaining);
      if (remaining <= 0) {
        clearInterval(timer);
        setTimeLeft(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  };



  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const months = Array.from({ length: 18 }, (_, i) => i + 1);
  const tokensReleased = [
    "3%", "4%", "4%", "4%", "4%", "5%", "6%", "7%", "8%", "9%", "10%", "11%",
    "7%", "7%", "5%", "3%", "2%", "1%"
  ];

  const visibleItems = isMobile && !showMore ? 5 : months.length;

  return (
    <>
      <section className="project-miners">
        <div className="custom-container">
          <div className="parent">
            <div className="left-side">
              <div className="main-content">
                <h5>
                  <img
                    src="\assets\gemsnodeslanding\icons\minericon.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  {t('gemminerhead')}
                </h5>
                <h4>
                  <span>{t('tokenproject')} </span>
                </h4>
                <p>
                  {t('minersarebuilt')}
                </p>
                <div className="miner-box">
                  <img
                    src="\assets\alldetailpages\miners\shadow-box.png"
                    alt="img"
                    className="img-fluid shadow-box"
                  />
                  <h6>{t('price')}</h6>
                  <p>
                    {t('minersold')}
                  </p>
                  <div className="hardcap-ifexist">
                    <ProgressBar now={(firtMillon / 1000000) * 100} />
                  </div>
                  <div
                    className={
                      timeLeft > 0
                        ? "twice-btns whentimersrunclasss"
                        : "twice-btns"
                    }
                  >
                    {timeLeft > 0 ? (
                      <a
                        href=""
                        target="_blank"
                        className="btn-green"
                        style={{ pointerEvents: "none" }}
                      >
                        Sale Starts in: {formatTime(timeLeft)}
                      </a>
                    ) : (
                      <a
                        href="https://buyminers.gems.vip/"
                        target="_blank"
                        className="btn-green"
                      >
                        {t('btnmercury')}
                      </a>
                    )}
                    <Link to="/miners" className="btn-transparent">
                      {t('btnlearn')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="right-side">
              {/* <div className="upper-text">
                <h5>gems Miners</h5>
                <p>SERIES: MERCURY</p>
              </div> */}
              <div className="slider">
                <Slider {...settings}>
                  <div className="single-card">
                    {
                      languageselected === "en" || languageselected === null ?

                        <>
                          <img
                            src="\assets\gemsnodeslanding\miners\1.png"
                            alt="img"
                            className="img-fluid hide-in-light-theme"
                          />
                          <img
                            src="\assets\gemsnodeslanding\miners\1light.png"
                            alt="img"
                            className="img-fluid d-none show-in-light-theme"
                          /></>
                        :
                        <>
                          <img
                            src="\assets\gemsnodeslanding\miners\1jp.png"
                            alt="img"
                            className="img-fluid hide-in-light-theme"
                          />
                          <img
                            src="\assets\gemsnodeslanding\miners\1jplight.png"
                            alt="img"
                            className="img-fluid d-none show-in-light-theme"
                          />
                        </>
                    }
                  </div>
                  <div className="single-card">
                    {
                      languageselected === "en" || languageselected === null ? <><img
                        src="\assets\gemsnodeslanding\miners\2.png"
                        alt="img"
                        className="img-fluid hide-in-light-theme"
                      />
                        <img
                          src="\assets\gemsnodeslanding\miners\2light.png"
                          alt="img"
                          className="img-fluid d-none show-in-light-theme"
                        /></> : <>
                        <img
                          src="\assets\gemsnodeslanding\miners\2jp.png"
                          alt="img"
                          className="img-fluid hide-in-light-theme"
                        />
                        <img
                          src="\assets\gemsnodeslanding\miners\2jplight.png"
                          alt="img"
                          className="img-fluid d-none show-in-light-theme"
                        /></>
                    }


                  </div>
                  <div className="single-card">
                    {
                      languageselected === "en" || languageselected === null ? <><img
                        src="\assets\gemsnodeslanding\miners\3.png"
                        alt="img"
                        className="img-fluid hide-in-light-theme"
                      />
                        <img
                          src="\assets\gemsnodeslanding\miners\3light.png"
                          alt="img"
                          className="img-fluid d-none show-in-light-theme"
                        /></> : <><img
                          src="\assets\gemsnodeslanding\miners\3jp.png"
                          alt="img"
                          className="img-fluid hide-in-light-theme"
                        />
                        <img
                          src="\assets\gemsnodeslanding\miners\3jplight.png"
                          alt="img"
                          className="img-fluid d-none show-in-light-theme"
                        /></>
                    }



                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MineProjectSlide />
      <section className="bottom-cards-nodes " style={{ paddingTop: "50px" }}>
        <div className="custom-container">
          <h6 className="main-headinginsideminer">{t('Nonlinerartext')}</h6>
          <div className="main-img" onClick={() => window.innerWidth <= 768 && setShow1(true)}>
            <img src="\assets\gemsnodeslanding\vesting\vestingdark.png" alt="img" className="img-fluid hide-in-light-theme" />
            <img src="\assets\gemsnodeslanding\vesting\vestinglight.png" alt="img" className="img-fluid d-none show-in-light-theme" />
          </div>
          <div className="valuespermonth">
            <div className="firstrow">
              <h6>Months</h6>
              {months.slice(0, visibleItems).map((month, index) => (
                <p key={index}>{month}</p>
              ))}
            </div>
            <div className="firstrow">
              <h6>Tokens Released (%)</h6>
              {tokensReleased.slice(0, visibleItems).map((token, index) => (
                <p key={index}>{token}</p>
              ))}
            </div>


          </div>
          {isMobile && (
            <button className="btn-showmorenodes" onClick={() => setShowMore(!showMore)}>
              {showMore ? "Show Less" : "Show More"}
            </button>
          )}
        </div>

      </section>

      <section className="bottom-cards-nodes " style={{ paddingTop: "50px" }}>
        <div className="custom-container">
          <h6 className="main-headinginsideminer">{t('benifithead')}</h6>
          <div className="parent m-0">
            <div className="single-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M24.4067 12.5417H17.5C16.9595 12.5386 16.442 12.3226 16.0597 11.9403C15.6775 11.5581 15.4614 11.0406 15.4584 10.5V3.59337C15.459 3.30042 15.5222 3.01099 15.6439 2.74451C15.7656 2.47803 15.943 2.24068 16.164 2.0484C16.385 1.85612 16.6446 1.71335 16.9253 1.62969C17.2061 1.54604 17.5015 1.52342 17.7917 1.56337C19.9758 1.87833 21.9993 2.89174 23.5596 4.4521C25.12 6.01246 26.1334 8.03595 26.4484 10.22C26.4883 10.5103 26.4657 10.8057 26.3821 11.0864C26.2984 11.3672 26.1556 11.6268 25.9633 11.8478C25.7711 12.0688 25.5337 12.2461 25.2672 12.3678C25.0008 12.4895 24.7113 12.5528 24.4184 12.5534L24.4067 12.5417ZM17.5 3.29004C17.4317 3.29167 17.3659 3.31634 17.3134 3.36004C17.2492 3.42107 17.2115 3.50485 17.2084 3.59337V10.5C17.2084 10.5774 17.2391 10.6516 17.2938 10.7063C17.3485 10.761 17.4227 10.7917 17.5 10.7917H24.4067C24.4952 10.7886 24.579 10.7509 24.64 10.6867C24.6855 10.6352 24.7104 10.5687 24.71 10.5C24.4506 8.67977 23.6075 6.99284 22.3074 5.69271C21.0072 4.39258 19.3203 3.54946 17.5 3.29004Z"
                  fill="#30F1B6"
                />
                <path
                  d="M24.4067 12.5417H17.5C16.9595 12.5386 16.442 12.3226 16.0597 11.9403C15.6775 11.5581 15.4614 11.0406 15.4584 10.5V3.59337C15.459 3.30042 15.5222 3.01099 15.6439 2.74451C15.7656 2.47803 15.943 2.24068 16.164 2.0484C16.385 1.85612 16.6446 1.71335 16.9253 1.62969C17.2061 1.54604 17.5015 1.52342 17.7917 1.56337C19.9758 1.87833 21.9993 2.89174 23.5596 4.4521C25.12 6.01246 26.1334 8.03595 26.4484 10.22C26.4883 10.5103 26.4657 10.8057 26.3821 11.0864C26.2984 11.3672 26.1556 11.6268 25.9633 11.8478C25.7711 12.0688 25.5337 12.2461 25.2672 12.3678C25.0008 12.4895 24.7113 12.5528 24.4184 12.5534L24.4067 12.5417ZM17.5 3.29004C17.4317 3.29167 17.3659 3.31634 17.3134 3.36004C17.2492 3.42107 17.2115 3.50485 17.2084 3.59337V10.5C17.2084 10.5774 17.2391 10.6516 17.2938 10.7063C17.3485 10.761 17.4227 10.7917 17.5 10.7917H24.4067C24.4952 10.7886 24.579 10.7509 24.64 10.6867C24.6855 10.6352 24.7104 10.5687 24.71 10.5C24.4506 8.67977 23.6075 6.99284 22.3074 5.69271C21.0072 4.39258 19.3203 3.54946 17.5 3.29004Z"
                  fill="#30F1B6"
                />
                <path
                  d="M12.2617 26.5417C11.5333 26.5412 10.8067 26.4709 10.0917 26.3317C7.5859 25.8268 5.34068 24.4489 3.75591 22.4433C2.17114 20.4377 1.34972 17.9347 1.43795 15.3801C1.52619 12.8255 2.51835 10.3851 4.23772 8.49368C5.95709 6.60223 8.29204 5.38248 10.8267 5.05171C11.1172 5.00977 11.4134 5.03097 11.695 5.11388C11.9766 5.19678 12.237 5.33943 12.4585 5.53211C12.6799 5.72478 12.8572 5.96295 12.9783 6.23036C13.0994 6.49778 13.1614 6.78816 13.16 7.08171V14.5834C13.16 14.6607 13.1908 14.7349 13.2454 14.7896C13.3001 14.8443 13.3743 14.875 13.4517 14.875H20.9534C21.2469 14.8737 21.5373 14.9357 21.8047 15.0568C22.0721 15.1778 22.3103 15.3551 22.503 15.5766C22.6956 15.7981 22.8383 16.0585 22.9212 16.3401C23.0041 16.6217 23.0253 16.9178 22.9834 17.2084C22.7755 18.6616 22.2743 20.0575 21.5102 21.311C20.746 22.5645 19.7349 23.6495 18.5384 24.5C16.7136 25.8251 14.5168 26.5397 12.2617 26.5417ZM11.0834 6.79004C9.41237 7.01379 7.83723 7.70026 6.53579 8.77194C5.23435 9.84362 4.25845 11.2578 3.71831 12.8548C3.17816 14.4519 3.09527 16.1681 3.479 17.8097C3.86274 19.4514 4.69781 20.953 5.88991 22.1451C7.08202 23.3373 8.58368 24.1723 10.2253 24.5561C11.867 24.9398 13.5832 24.8569 15.1802 24.3168C16.7772 23.7766 18.1914 22.8007 19.2631 21.4993C20.3348 20.1978 21.0213 18.6227 21.245 16.9517C21.2516 16.9119 21.2487 16.871 21.2366 16.8325C21.2244 16.794 21.2033 16.7589 21.175 16.73C21.1474 16.6981 21.1134 16.6722 21.0753 16.6541C21.0371 16.6361 20.9956 16.6261 20.9534 16.625H13.4167C12.8762 16.622 12.3586 16.4059 11.9764 16.0237C11.5942 15.6414 11.3781 15.1239 11.375 14.5834V7.08171C11.3739 7.03948 11.364 6.99796 11.3459 6.95979C11.3278 6.92162 11.302 6.88764 11.27 6.86004C11.2185 6.81459 11.1521 6.78968 11.0834 6.79004Z"
                  fill="#30F1B6"
                />
              </svg>
              <h6>{t('income')}</h6>
              <p>
                {t('incomepara')}
              </p>
            </div>
            <div className="single-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M15.1666 26.5416H12.8333C12.2927 26.5385 11.7752 26.3224 11.393 25.9402C11.0107 25.558 10.7946 25.0405 10.7916 24.4999V23.8933C10.7839 23.8185 10.7507 23.7487 10.6976 23.6956C10.6445 23.6424 10.5747 23.6092 10.4999 23.6016C10.1966 23.4849 9.89325 23.3683 9.60159 23.2283C9.54622 23.1916 9.4813 23.1721 9.41492 23.1721C9.34854 23.1721 9.28362 23.1916 9.22825 23.2283L8.79659 23.6599C8.41393 24.0411 7.89584 24.2551 7.35575 24.2551C6.81566 24.2551 6.29757 24.0411 5.91492 23.6599L4.30492 22.0383C3.92377 21.6556 3.70977 21.1375 3.70977 20.5974C3.70977 20.0573 3.92377 19.5392 4.30492 19.1566L4.73659 18.7249C4.77284 18.6673 4.79207 18.6005 4.79207 18.5324C4.79207 18.4643 4.77284 18.3976 4.73659 18.3399C4.59659 18.0599 4.47992 17.7566 4.36325 17.4533C4.34637 17.387 4.30915 17.3278 4.25682 17.2838C4.2045 17.2399 4.13972 17.2135 4.07159 17.2083H3.49992C2.95938 17.2052 2.44185 16.9891 2.05963 16.6069C1.6774 16.2247 1.46131 15.7071 1.45825 15.1666V12.8333C1.46131 12.2927 1.6774 11.7752 2.05963 11.393C2.44185 11.0107 2.95938 10.7946 3.49992 10.7916H4.10659C4.18133 10.7839 4.25115 10.7507 4.30428 10.6976C4.3574 10.6445 4.39059 10.5747 4.39825 10.4999C4.51492 10.1966 4.63159 9.89325 4.77159 9.61325C4.80784 9.55559 4.82707 9.48886 4.82707 9.42075C4.82707 9.35264 4.80784 9.28591 4.77159 9.22825L4.33992 8.79659C3.95877 8.41393 3.74477 7.89584 3.74477 7.35575C3.74477 6.81566 3.95877 6.29757 4.33992 5.91492L5.96159 4.30492C6.34424 3.92377 6.86233 3.70977 7.40242 3.70977C7.94251 3.70977 8.4606 3.92377 8.84325 4.30492L9.33325 4.73659C9.39091 4.77284 9.45764 4.79207 9.52575 4.79207C9.59386 4.79207 9.66059 4.77284 9.71825 4.73659C9.99825 4.59659 10.3016 4.47992 10.6049 4.36325C10.6711 4.34637 10.7304 4.30915 10.7743 4.25682C10.8183 4.2045 10.8447 4.13972 10.8499 4.07159V3.49992C10.8526 2.96927 11.0607 2.46028 11.4304 2.07966C11.8002 1.69903 12.3029 1.47634 12.8333 1.45825H15.1666C15.7071 1.46131 16.2247 1.6774 16.6069 2.05963C16.9891 2.44185 17.2052 2.95938 17.2083 3.49992V4.10659C17.2135 4.17472 17.2399 4.2395 17.2838 4.29182C17.3278 4.34415 17.387 4.38137 17.4533 4.39825C17.7566 4.51492 18.0599 4.63159 18.3399 4.77159C18.3976 4.80784 18.4643 4.82707 18.5324 4.82707C18.6005 4.82707 18.6673 4.80784 18.7249 4.77159L19.1566 4.33992C19.5392 3.95877 20.0573 3.74477 20.5974 3.74477C21.1375 3.74477 21.6556 3.95877 22.0383 4.33992L23.6949 5.99659C24.0761 6.37924 24.2901 6.89733 24.2901 7.43742C24.2901 7.97751 24.0761 8.4956 23.6949 8.87825L23.2633 9.33325C23.227 9.39091 23.2078 9.45764 23.2078 9.52575C23.2078 9.59386 23.227 9.66059 23.2633 9.71825C23.4033 9.99825 23.5199 10.3016 23.6366 10.6049C23.6535 10.6711 23.6907 10.7304 23.743 10.7743C23.7953 10.8183 23.8601 10.8447 23.9283 10.8499H24.4999C25.0306 10.8526 25.5396 11.0607 25.9202 11.4304C26.3008 11.8002 26.5235 12.3029 26.5416 12.8333V15.1666C26.5385 15.7071 26.3224 16.2247 25.9402 16.6069C25.558 16.9891 25.0405 17.2052 24.4999 17.2083H23.8933C23.8251 17.2135 23.7603 17.2399 23.708 17.2838C23.6557 17.3278 23.6185 17.387 23.6016 17.4533C23.4849 17.7566 23.3683 18.0599 23.2283 18.3516C23.1916 18.407 23.1721 18.4719 23.1721 18.5383C23.1721 18.6046 23.1916 18.6696 23.2283 18.7249L23.6599 19.1566C24.0411 19.5392 24.2551 20.0573 24.2551 20.5974C24.2551 21.1375 24.0411 21.6556 23.6599 22.0383L22.0033 23.6949C21.6206 24.0761 21.1025 24.2901 20.5624 24.2901C20.0223 24.2901 19.5042 24.0761 19.1216 23.6949L18.6899 23.2633C18.6346 23.2266 18.5696 23.2071 18.5033 23.2071C18.4369 23.2071 18.372 23.2266 18.3166 23.2633C18.0249 23.4033 17.7216 23.5199 17.4183 23.6366C17.352 23.6535 17.2928 23.6907 17.2488 23.743C17.2049 23.7953 17.1785 23.8601 17.1733 23.9283V24.4999C17.1704 25.0345 16.9591 25.5468 16.5844 25.9281C16.2097 26.3094 15.701 26.5294 15.1666 26.5416ZM9.47325 21.4316C9.79577 21.4343 10.114 21.5059 10.4066 21.6416C10.6454 21.7605 10.8908 21.8657 11.1416 21.9566C11.5479 22.0929 11.9013 22.353 12.1523 22.7003C12.4034 23.0476 12.5395 23.4647 12.5416 23.8933V24.4999C12.5416 24.5773 12.5723 24.6515 12.627 24.7062C12.6817 24.7609 12.7559 24.7916 12.8333 24.7916H15.1666C15.2439 24.7916 15.3181 24.7609 15.3728 24.7062C15.4275 24.6515 15.4583 24.5773 15.4583 24.4999V23.8933C15.4614 23.4636 15.5977 23.0454 15.8484 22.6965C16.0992 22.3475 16.452 22.0849 16.8583 21.9449C17.1138 21.8611 17.3633 21.7598 17.6049 21.6416C17.9861 21.4574 18.4149 21.3955 18.8326 21.4644C19.2503 21.5334 19.6365 21.7297 19.9383 22.0266L20.3699 22.4583C20.3961 22.4862 20.4277 22.5084 20.4628 22.5236C20.498 22.5388 20.5358 22.5466 20.5741 22.5466C20.6124 22.5466 20.6502 22.5388 20.6853 22.5236C20.7204 22.5084 20.7521 22.4862 20.7783 22.4583L22.4349 20.8016C22.4609 20.7755 22.4815 20.7446 22.4955 20.7106C22.5095 20.6765 22.5167 20.6401 22.5166 20.6033C22.5173 20.5254 22.4881 20.4502 22.4349 20.3933L22.0033 19.9616C21.7064 19.6598 21.51 19.2736 21.4411 18.8559C21.3722 18.4382 21.4341 18.0094 21.6183 17.6283C21.7365 17.3867 21.8378 17.1372 21.9216 16.8816C22.0616 16.4753 22.3242 16.1225 22.6731 15.8718C23.0221 15.621 23.4402 15.4847 23.8699 15.4816H24.4999C24.5773 15.4816 24.6515 15.4509 24.7062 15.3962C24.7609 15.3415 24.7916 15.2673 24.7916 15.1899V12.8333C24.7916 12.7559 24.7609 12.6817 24.7062 12.627C24.6515 12.5723 24.5773 12.5416 24.4999 12.5416H23.8933C23.4636 12.5385 23.0454 12.4022 22.6965 12.1514C22.3475 11.9007 22.0849 11.5478 21.9449 11.1416C21.863 10.8891 21.7616 10.6434 21.6416 10.4066C21.4591 10.025 21.3981 9.59665 21.467 9.17935C21.5358 8.76204 21.7312 8.37594 22.0266 8.07325L22.4583 7.64159C22.5114 7.58467 22.5407 7.50947 22.5399 7.43159C22.54 7.39478 22.5328 7.35832 22.5188 7.32429C22.5048 7.29026 22.4842 7.25932 22.4583 7.23325L20.8016 5.54159C20.7754 5.51368 20.7438 5.49145 20.7087 5.47624C20.6735 5.46104 20.6357 5.4532 20.5974 5.4532C20.5592 5.4532 20.5213 5.46104 20.4862 5.47624C20.4511 5.49145 20.4194 5.51368 20.3933 5.54159L19.9616 5.97325C19.6589 6.26866 19.2728 6.46399 18.8555 6.53285C18.4382 6.6017 18.0098 6.54076 17.6283 6.35825C17.3915 6.23825 17.1457 6.13683 16.8933 6.05492C16.487 5.91492 16.1342 5.65234 15.8834 5.30338C15.6327 4.95442 15.4964 4.53628 15.4933 4.10659V3.49992C15.4936 3.45848 15.485 3.41746 15.4682 3.37958C15.4514 3.34171 15.4268 3.30784 15.3958 3.28024C15.3649 3.25265 15.3285 3.23195 15.289 3.21954C15.2494 3.20713 15.2077 3.20328 15.1666 3.20825H12.8333C12.7559 3.20825 12.6817 3.23898 12.627 3.29368C12.5723 3.34838 12.5416 3.42256 12.5416 3.49992V4.10659C12.5385 4.53628 12.4022 4.95442 12.1514 5.30338C11.9007 5.65234 11.5478 5.91492 11.1416 6.05492C10.886 6.1387 10.6365 6.24005 10.3949 6.35825C10.0137 6.54244 9.58496 6.60431 9.16726 6.53539C8.74957 6.46647 8.36338 6.27013 8.06159 5.97325L7.62992 5.54159C7.60373 5.51368 7.57211 5.49145 7.53699 5.47624C7.50188 5.46104 7.46402 5.4532 7.42575 5.4532C7.38749 5.4532 7.34963 5.46104 7.31451 5.47624C7.2794 5.49145 7.24777 5.51368 7.22159 5.54159L5.54159 7.19825C5.51561 7.22432 5.49502 7.25526 5.48101 7.28929C5.467 7.32332 5.45983 7.35978 5.45992 7.39659C5.45917 7.47447 5.48841 7.54967 5.54159 7.60659L5.97325 8.03825C6.27013 8.34005 6.46647 8.72623 6.53539 9.14393C6.60431 9.56162 6.54244 9.99041 6.35825 10.3716C6.24159 10.6166 6.13659 10.8616 6.04325 11.1183C5.9069 11.5245 5.64686 11.878 5.29956 12.129C4.95226 12.3801 4.53512 12.5162 4.10659 12.5183H3.49992C3.42256 12.5183 3.34838 12.549 3.29368 12.6037C3.23898 12.6584 3.20825 12.7326 3.20825 12.8099V15.1433C3.20825 15.2206 3.23898 15.2948 3.29368 15.3495C3.34838 15.4042 3.42256 15.4349 3.49992 15.4349H4.10659C4.53628 15.438 4.95442 15.5744 5.30338 15.8251C5.65234 16.0758 5.91492 16.4287 6.05492 16.8349C6.1387 17.0905 6.24005 17.34 6.35825 17.5816C6.54244 17.9628 6.60431 18.3915 6.53539 18.8092C6.46647 19.2269 6.27013 19.6131 5.97325 19.9149L5.54159 20.3466C5.48841 20.4035 5.45917 20.4787 5.45992 20.5566C5.45983 20.5934 5.467 20.6299 5.48101 20.6639C5.49502 20.6979 5.51561 20.7289 5.54159 20.7549L7.19825 22.4116C7.22444 22.4395 7.25607 22.4617 7.29118 22.4769C7.3263 22.4921 7.36415 22.5 7.40242 22.5C7.44068 22.5 7.47854 22.4921 7.51366 22.4769C7.54877 22.4617 7.5804 22.4395 7.60659 22.4116L8.03825 21.9799C8.22858 21.7971 8.45366 21.6544 8.70015 21.5602C8.94665 21.4661 9.20954 21.4223 9.47325 21.4316Z"
                  fill="#30F1B6"
                />
                <path
                  d="M13.9999 21.2916C12.5578 21.2916 11.148 20.8639 9.94889 20.0627C8.74978 19.2615 7.81519 18.1227 7.2633 16.7903C6.71141 15.4579 6.56701 13.9918 6.84836 12.5774C7.12971 11.1629 7.82418 9.86369 8.84394 8.84394C9.86369 7.82418 11.1629 7.12971 12.5774 6.84836C13.9918 6.56701 15.4579 6.71141 16.7903 7.2633C18.1227 7.81519 19.2615 8.74978 20.0627 9.94889C20.8639 11.148 21.2916 12.5578 21.2916 13.9999C21.2916 15.9338 20.5234 17.7885 19.1559 19.1559C17.7885 20.5234 15.9338 21.2916 13.9999 21.2916ZM13.9999 8.45826C12.9039 8.45826 11.8325 8.78327 10.9211 9.39219C10.0098 10.0011 9.29953 10.8666 8.88009 11.8792C8.46065 12.8918 8.35091 14.0061 8.56474 15.081C8.77856 16.156 9.30636 17.1435 10.0814 17.9185C10.8564 18.6935 11.8438 19.2213 12.9188 19.4351C13.9938 19.6489 15.108 19.5392 16.1206 19.1198C17.1332 18.7003 17.9987 17.99 18.6077 17.0787C19.2166 16.1674 19.5416 15.096 19.5416 13.9999C19.5416 12.5302 18.9577 11.1206 17.9185 10.0814C16.8792 9.04211 15.4697 8.45826 13.9999 8.45826Z"
                  fill="#30F1B6"
                />
                <path
                  d="M15.1667 16.0415C15.0517 16.042 14.9378 16.0196 14.8316 15.9755C14.7254 15.9315 14.6291 15.8666 14.5483 15.7848L13.3817 14.6182C13.2175 14.4542 13.1252 14.2318 13.125 13.9998V11.6665C13.125 11.4344 13.2172 11.2119 13.3813 11.0478C13.5454 10.8837 13.7679 10.7915 14 10.7915C14.2321 10.7915 14.4546 10.8837 14.6187 11.0478C14.7828 11.2119 14.875 11.4344 14.875 11.6665V13.6382L15.785 14.5482C15.9489 14.7122 16.0409 14.9346 16.0409 15.1665C16.0409 15.3984 15.9489 15.6208 15.785 15.7848C15.7042 15.8666 15.6079 15.9315 15.5017 15.9755C15.3955 16.0196 15.2816 16.042 15.1667 16.0415Z"
                  fill="#30F1B6"
                />
              </svg>
              <h6>{t('tierhead')}</h6>
              <p>
                {t('tirespara')}
              </p>
            </div>
            <div className="single-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M11.4566 24.2083H3.70989C3.41792 24.206 3.12979 24.1415 2.86472 24.0191C2.59966 23.8967 2.36375 23.7191 2.17273 23.4983C1.98172 23.2775 1.84 23.0185 1.75703 22.7385C1.67405 22.4586 1.65173 22.1642 1.69155 21.8749L2.47322 17.2083C2.55114 16.7303 2.7974 16.2959 3.16752 15.9835C3.53764 15.6711 4.00725 15.5014 4.49155 15.5049H10.6749C11.1592 15.5014 11.6288 15.6711 11.9989 15.9835C12.369 16.2959 12.6153 16.7303 12.6932 17.2083L13.4749 21.8749C13.5147 22.1642 13.4924 22.4586 13.4094 22.7385C13.3264 23.0185 13.1847 23.2775 12.9937 23.4983C12.8027 23.7191 12.5668 23.8967 12.3017 24.0191C12.0366 24.1415 11.7485 24.206 11.4566 24.2083ZM4.45655 17.2083C4.38541 17.2169 4.31993 17.2514 4.27259 17.3051C4.22525 17.3589 4.19937 17.4283 4.19989 17.4999L3.41822 22.1666C3.41238 22.2082 3.41561 22.2507 3.42769 22.2909C3.43977 22.3312 3.46042 22.3684 3.48822 22.3999C3.51582 22.4319 3.5498 22.4578 3.58797 22.4758C3.62614 22.4939 3.66766 22.5038 3.70989 22.5049H11.4566C11.4988 22.5038 11.5403 22.4939 11.5785 22.4758C11.6166 22.4578 11.6506 22.4319 11.6782 22.3999C11.706 22.3684 11.7267 22.3312 11.7387 22.2909C11.7508 22.2507 11.7541 22.2082 11.7482 22.1666L10.9666 17.4999C10.9554 17.4309 10.9198 17.3682 10.8662 17.3232C10.8127 17.2783 10.7448 17.254 10.6749 17.2549L4.45655 17.2083Z"
                  fill="#30F1B6"
                />
                <path
                  d="M24.2898 24.2083H16.5431C16.2512 24.206 15.963 24.1415 15.698 24.0191C15.4329 23.8967 15.197 23.7191 15.006 23.4983C14.815 23.2775 14.6733 23.0185 14.5903 22.7385C14.5073 22.4586 14.485 22.1642 14.5248 21.8749L15.3065 17.2083C15.3844 16.7303 15.6306 16.2959 16.0008 15.9835C16.3709 15.6711 16.8405 15.5014 17.3248 15.5049H23.5081C23.9924 15.5014 24.462 15.6711 24.8322 15.9835C25.2023 16.2959 25.4485 16.7303 25.5265 17.2083L26.3081 21.8749C26.348 22.1642 26.3256 22.4586 26.2427 22.7385C26.1597 23.0185 26.018 23.2775 25.827 23.4983C25.6359 23.7191 25.4 23.8967 25.135 24.0191C24.8699 24.1415 24.5818 24.206 24.2898 24.2083ZM17.2898 17.2083C17.2199 17.2074 17.152 17.2316 17.0985 17.2766C17.0449 17.3216 17.0093 17.3843 16.9981 17.4533L16.2165 22.1199C16.2106 22.1616 16.2139 22.204 16.2259 22.2443C16.238 22.2845 16.2587 22.3217 16.2865 22.3533C16.3141 22.3852 16.348 22.4111 16.3862 22.4292C16.4244 22.4473 16.4659 22.4572 16.5081 22.4583H24.2548C24.297 22.4572 24.3386 22.4473 24.3767 22.4292C24.4149 22.4111 24.4489 22.3852 24.4765 22.3533C24.5043 22.3217 24.5249 22.2845 24.537 22.2443C24.5491 22.204 24.5523 22.1616 24.5465 22.1199L23.7648 17.4533C23.7536 17.3843 23.718 17.3216 23.6645 17.2766C23.611 17.2316 23.543 17.2074 23.4731 17.2083H17.2898Z"
                  fill="#30F1B6"
                />
                <path
                  d="M18.4333 14.875H9.56661C9.26757 14.8729 8.9726 14.8055 8.70232 14.6775C8.43205 14.5495 8.193 14.364 8.00188 14.134C7.81076 13.904 7.67219 13.635 7.59585 13.3458C7.51952 13.0567 7.50726 12.7544 7.55994 12.46L8.42328 7.79333C8.51252 7.32575 8.76146 6.90371 9.12749 6.59939C9.49353 6.29507 9.95393 6.12738 10.4299 6.125H17.5699C18.046 6.12738 18.5064 6.29507 18.8724 6.59939C19.2384 6.90371 19.4874 7.32575 19.5766 7.79333L20.4399 12.46C20.4926 12.7544 20.4804 13.0567 20.404 13.3458C20.3277 13.635 20.1891 13.904 19.998 14.134C19.8069 14.364 19.5678 14.5495 19.2976 14.6775C19.0273 14.8055 18.7323 14.8729 18.4333 14.875ZM10.4299 7.875C10.3546 7.87801 10.2834 7.91007 10.2312 7.96444C10.179 8.01882 10.1499 8.09129 10.1499 8.16667L9.33328 12.8333C9.31471 12.8715 9.30506 12.9134 9.30506 12.9558C9.30506 12.9983 9.31471 13.0402 9.33328 13.0783C9.36088 13.1103 9.39485 13.1362 9.43302 13.1542C9.4712 13.1723 9.51272 13.1822 9.55494 13.1833H18.4216C18.4638 13.1822 18.5054 13.1723 18.5435 13.1542C18.5817 13.1362 18.6157 13.1103 18.6433 13.0783C18.6656 13.042 18.6793 13.001 18.6833 12.9585C18.6873 12.9161 18.6816 12.8733 18.6666 12.8333L17.8499 8.16667C17.8367 8.10176 17.8018 8.04329 17.7509 8.00088C17.7 7.95847 17.6362 7.93465 17.5699 7.93333L10.4299 7.875Z"
                  fill="#30F1B6"
                />
              </svg>
              <h6>{t('tradinghead')}</h6>
              <p>
                {t('tradingpara')}
              </p>
            </div>
            <div className="single-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M16.3332 10.2083H11.6665C11.505 10.2073 11.3468 10.1622 11.2091 10.0779C11.0713 9.99364 10.9592 9.87332 10.8848 9.72996L7.80483 3.56996C7.69486 3.34624 7.64358 3.09823 7.65583 2.84925C7.66807 2.60026 7.74344 2.35848 7.87483 2.14663C8.0039 1.9348 8.18566 1.76003 8.4024 1.63939C8.61914 1.51876 8.86346 1.45636 9.1115 1.4583H18.8882C19.1362 1.45636 19.3805 1.51876 19.5973 1.63939C19.814 1.76003 19.9958 1.9348 20.1248 2.14663C20.2562 2.35848 20.3316 2.60026 20.3438 2.84925C20.3561 3.09823 20.3048 3.34624 20.1948 3.56996L17.1148 9.72996C17.0405 9.87332 16.9283 9.99364 16.7906 10.0779C16.6528 10.1622 16.4947 10.2073 16.3332 10.2083ZM12.2032 8.4583H15.7965L18.4215 3.2083H9.57817L12.2032 8.4583Z"
                  fill="#30F1B6"
                />
                <path
                  d="M19.9383 26.5417H8.0616C7.39575 26.5429 6.74602 26.3369 6.2025 25.9522C5.65899 25.5676 5.24861 25.0234 5.02827 24.395C4.4963 22.9003 4.28561 21.3101 4.40994 19.7284C4.86494 13.6967 10.2433 9.13503 11.2116 8.55169C11.3525 8.48123 11.5094 8.44905 11.6666 8.45836H16.3333C16.4937 8.45975 16.6508 8.50406 16.7883 8.58669C17.7566 9.17003 23.1349 13.7317 23.5899 19.7634C23.7143 21.3451 23.5036 22.9353 22.9716 24.43C22.7455 25.0518 22.3326 25.5885 21.7896 25.9665C21.2465 26.3446 20.5999 26.5455 19.9383 26.5417ZM11.9349 10.2084C10.7683 11.0367 6.52161 15.0267 6.10161 19.9034C6.00879 21.233 6.1915 22.5676 6.63827 23.8234C6.73653 24.1092 6.92252 24.3567 7.16973 24.5306C7.41694 24.7044 7.71273 24.7958 8.01494 24.7917H19.9383C20.2405 24.7958 20.5363 24.7044 20.7835 24.5306C21.0307 24.3567 21.2167 24.1092 21.3149 23.8234C21.7617 22.5676 21.9444 21.233 21.8516 19.9034C21.4783 15.0267 17.1849 11.0367 16.0183 10.2084H11.9349Z"
                  fill="#30F1B6"
                />
                <path
                  d="M15.1666 13.7082C14.9837 13.7081 14.8054 13.6506 14.6568 13.5439C14.5082 13.4372 14.3968 13.2866 14.3383 13.1132L13.1716 9.61324C13.1073 9.39623 13.1295 9.16272 13.2337 8.96177C13.3379 8.76082 13.5159 8.60806 13.7303 8.53558C13.9447 8.4631 14.1789 8.47653 14.3836 8.57306C14.5884 8.66958 14.7477 8.8417 14.8283 9.05324L15.9949 12.5532C16.0409 12.6654 16.063 12.7859 16.0599 12.907C16.0569 13.0282 16.0287 13.1474 15.9771 13.2571C15.9256 13.3667 15.8518 13.4645 15.7605 13.5442C15.6691 13.6239 15.5623 13.6837 15.4466 13.7199C15.3533 13.7329 15.2585 13.729 15.1666 13.7082Z"
                  fill="#30F1B6"
                />
                <path
                  d="M22.1665 10.2083H15.1665C14.9344 10.2083 14.7119 10.1161 14.5478 9.95197C14.3837 9.78788 14.2915 9.56532 14.2915 9.33325C14.2915 9.10119 14.3837 8.87863 14.5478 8.71453C14.7119 8.55044 14.9344 8.45825 15.1665 8.45825H22.1665C22.3986 8.45825 22.6211 8.55044 22.7852 8.71453C22.9493 8.87863 23.0415 9.10119 23.0415 9.33325C23.0415 9.56532 22.9493 9.78788 22.7852 9.95197C22.6211 10.1161 22.3986 10.2083 22.1665 10.2083Z"
                  fill="#30F1B6"
                />
                <path
                  d="M13.9998 21.8749C13.3653 21.8749 12.745 21.6868 12.2174 21.3342C11.6898 20.9817 11.2786 20.4806 11.0357 19.8944C10.7929 19.3081 10.7294 18.663 10.8532 18.0407C10.9769 17.4183 11.2825 16.8466 11.7312 16.398C12.1799 15.9493 12.7516 15.6437 13.3739 15.5199C13.9963 15.3961 14.6414 15.4596 15.2276 15.7025C15.8139 15.9453 16.3149 16.3565 16.6675 16.8841C17.02 17.4117 17.2082 18.032 17.2082 18.6666C17.2082 19.5175 16.8702 20.3335 16.2685 20.9352C15.6668 21.5369 14.8507 21.8749 13.9998 21.8749ZM13.9998 17.2083C13.7114 17.2083 13.4295 17.2938 13.1896 17.454C12.9498 17.6143 12.7629 17.842 12.6525 18.1085C12.5421 18.375 12.5133 18.6682 12.5695 18.9511C12.6258 19.234 12.7647 19.4938 12.9686 19.6978C13.1726 19.9017 13.4324 20.0406 13.7153 20.0969C13.9982 20.1532 14.2914 20.1243 14.5579 20.0139C14.8244 19.9035 15.0522 19.7166 15.2124 19.4768C15.3726 19.237 15.4582 18.955 15.4582 18.6666C15.4582 18.2798 15.3045 17.9089 15.031 17.6354C14.7575 17.3619 14.3866 17.2083 13.9998 17.2083Z"
                  fill="#30F1B6"
                />
              </svg>
              <h6>{t('earninhead')}</h6>
              <p>
                {t('earningpara')}
              </p>
            </div>
          </div>
        </div>
      </section>


      <Modal className='common-modal-style image-preview distribution-modl' show={show1} onHide={handleClose1} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-0 paddingsetmobile">
          <img src="\assets\gemsnodeslanding\vesting\vestingdark.png" alt="img" className="img-fluid hide-in-light-theme force-landscape" />
          <img src="\assets\gemsnodeslanding\vesting\vestinglight.png" alt="img" className="img-fluid d-none show-in-light-theme force-landscape" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProjectMiners;
